module.exports = __webpack_public_path__ + "a8a79e1bfd6be10ec63b7301428f7475.png";